import CollapseCard from '@components/miscellany/collapse/collapse_card'
import EditableLable from '@components/miscellany/editable_label/editable_label'
import ToggleButton from '@components/miscellany/toggle_button/toggle_button'
import store from '../../../../store'
import('./reference_values.css')

export default function ReferenceValues(opts){
    BaseConstructor.call(this)
    let container = opts.container
    let context = this
    let chart_name = opts.chart_name
    let axis_name = opts.axis_name
    let reference_items_list = []
    let elements = {}
    this.generate = () =>{
        

        elements.title = this.createElement('div', '', buildTitle())
        elements.controls_container = this.createElement('div','reference-value-item-wrapper','')
        
        buildReferenceItemsList()

        let collapse = new CollapseCard(
            {title_options:{text:buildTitle(), icon_options:{}}, 
            content_options:{content: elements.controls_container}
        })
        // collapse.setContent(elements.controls_container)

        $(container).append(collapse.generate())

        //atualizando o nome do chart internamente caso seja alterado por outro componente
        store.subscribe('chart-prop-updated', data=>{
            if(data.old_value == chart_name){
                chart_name = data.value
            }
        })

    }

    this.addReferenceItem = (title) =>{
        
        $(elements.controls_container).find('.no-reference-values-wrapper').hide()

        let item = new ReferenceItem({title:title, chart_name:chart_name, axis_name:axis_name})
        item.generate()

        $(elements.controls_container).append(item.getElement())
        
        item.on('input:change', data=>{
            context.trigger('input:change', {option: data.current_title, input_name: data.input_name, value:data.value})
        })

        item.on('title:change', data=>{
            store.updateChartNestedPropName(chart_name, `series.${axis_name}.reference_values.fields`, data.previous, data.current)
        })

        item.on('item:destroy', data =>{
            removeReferenceFromStore(data.current_title)
        })
    }

    function removeReferenceFromStore(current_title){
        store.removeChartNestedProp(chart_name, `series.${axis_name}.reference_values.fields`, current_title)
    }

    function buildReferenceItemsList(){
        elements.no_data = context.createElement('div', 'no-reference-values-wrapper', 'Sem valores de referência')
        let reference_values = store.getChartNestedProp(chart_name, `series.${axis_name}.reference_values.fields`)    
        if(reference_values){
            if(Object.keys(reference_values).length == 0){
                $(elements.controls_container).html(elements.no_data)
            } else {
                $.each(reference_values, (title, options) => {
                    context.addReferenceItem(title)
                })
            }
        } else {
            $(elements.controls_container).html(elements.no_data)
        }
    }

    function buildTitle(){
        
        let show = store.getChartNestedProp(chart_name, `series.${axis_name}.reference_values.show`) || 'true'
        let title = context.createElement('div', 'reference-values-title-container')
        let text = context.createElement('div', '', 'VALORES DE REFERÊNCIA')
        let button = context.createElement('div')
        let button_add = context.createElement('div', '', '')

        show = show === 'true' //convertendo pra Boolean

        let toggleButton = new ToggleButton({
            container: button,
            custom_class: 'control-button control-button-visibility',
            states: [
                {title: '<i class="fas fa-eye"></i>', active: Boolean(show), id:'show', classList: 'active'},
                {title: '<i class="fa fa-eye-slash"></i>', active: !Boolean(show), id:'hide', classList: ''}
                // {title: 'Exibir', active: Boolean(show), id:'show', classList: 'active'},
                // {title: 'Exibir', active: !Boolean(show), id:'hide', classList: ''}
            ]
        })

        toggleButton.generate()

        toggleButton.on('click', data=>{
            store.setChartNestedProp(chart_name,`series.${axis_name}.reference_values.show`, (data.toState.id == 'show' ? true : false))
        })

        let button_el = context.createElement('button', 'control-button control-button-add', '<i class="fas fa-plus"></i>')
        button_el.type = 'button'
        $(button_add).append(button_el)

        

        $(button_add).on('click', () =>{
            let reference_values = store.getChartNestedProp(chart_name, `series.${axis_name}.reference_values.fields`)
            let key_name = `Valor de referência #${reference_values ? Object.keys(reference_values).length + 1 : 1}`
            context.addReferenceItem(key_name)
            store.setChartNestedProp(chart_name, `series.${axis_name}.reference_values.fields.${key_name}.options`, {value: '', color: ''})
            context.trigger('reference-item-handled')
        })

        $(title).append(text, button, button_add)
        return title
    }
}




function ReferenceItem(opts){
    BaseConstructor.call(this)
    let elements = {}
    let context = this
    let chart_name = opts.chart_name
    let axis_name = opts.axis_name
    let current_title = opts.title
    this.getElement = () =>{
        return elements.container
    }


    this.destroy = () =>{
        this.getElement().remove()
    }

    this.generate = () =>{
        let editable_label = new EditableLable({text: current_title})
        editable_label.on('value-updated', data =>{
            current_title = data.current
            context.trigger('title:change', data)
        })

        elements.container = document.createElement('div')
        elements.title_container = context.createElement('div', 'reference-value-item-title-container')
        elements.title = context.createElement('div', 'reference-value-item-title', editable_label.getElement())
        elements.button_remove = context.createElement('div', 'reference-value-item-title', generateRemoveButton())
        elements.hide_button = context.createElement('div', 'reference-value-item-title', generateHideButton())
        $(elements.title_container).append(elements.title, elements.button_remove,elements.hide_button)
        elements.controls_container = context.createElement('div', 'reference-value-item-controls-container', controlsByItem(opts.title))

        $(elements.container).append(elements.title_container,elements.controls_container)
    }


    init()
    function init(){
        
    }

    function generateRemoveButton(){
        let el = context.createElement('button', 'control-button control-button-remove', '<i class="fas fa-times"></i>')
        el.type = 'button'
        $(el).on('click', () =>{
            context.trigger('item:destroy', {current_title: current_title})
            context.destroy()
        })
        return el
    }

    function generateHideButton(){
        
        let show = store.getChartNestedProp(chart_name, `series.${axis_name}.reference_values.fields.${current_title}.show`) || 'true'
        let icon = context.createElement('i', ((show == 'true') ? 'fas fa-eye' : 'fas fas fa-eye fa-eye-slash'))
        let el = context.createElement('button', `control-button control-button-visibility ${show ? 'active' : ''}`, icon)
        
        el.type = 'button'
        $(el).on('click', () =>{
            let show = !$(icon).hasClass('fa-eye-slash')
            $(icon).toggleClass('fa-eye-slash', show)
            $(el).toggleClass('active', !show)
            store.setChartNestedProp(chart_name, `series.${axis_name}.reference_values.fields.${current_title}.show`, !show)

        })
        return el
    }

    function controlsByItem(title){
        let container = context.createElement('div')
        // container.classList.add('form-group form-floating')
        
        {
            [["text", "value"], ["text", "color"]].forEach(data=>{
                let wrapper = document.createElement('div')
                let current_value = store.getChartNestedProp(chart_name, `series.${axis_name}.reference_values.fields.${title}.options.${data[1]}`)
                let label = document.createElement('label')
                label.innerHTML = data[1]
                if(data[1] == 'color'){
                    let input = document.createElement('div','','')
                    $(wrapper).append(label,input)
                    generatePicker(input)
                } else {
                    let input = document.createElement('input')
                    $(input).addClass('form-control')
                    input.type = data[0]
                    input.placeholder = data[1]
                    input.value = current_value
                    $(wrapper).append(input, label)

                    $(input).on('change', (e)=>{
                        context.trigger('input:change', {current_title: current_title, value: e.target.value, input_name: data[1]})
                    })
                    $(wrapper).addClass('form-group form-floating')
                }
                $(container).append(wrapper)
            })
        }
        return container
    }

    function generatePicker(el){
        const pickr = Pickr.create({
            el: el,
            theme: 'nano',
            default: store.getChartNestedProp(chart_name, `series.${axis_name}.reference_values.fields.${current_title}.options.color`) || 'black',      
            components: {
        
                // Main components
                preview: true,
                opacity: false,
                hue: true,
        
                // Input / output Options
                interaction: {
                    hex: true,
                    input: true,
                    clear: false,
                    save: true
                }
            }
        });

        pickr.on('change', (color, source, instance) =>{
            pickr.applyColor(true)
            context.trigger('input:change', {current_title: current_title, value: color.toHEXA().toString(), input_name: 'color'})
        })
    }
}

ReferenceValues.prototype = Object.create(BaseConstructor.prototype)
ReferenceItem.prototype = Object.create(BaseConstructor.prototype)